module.exports = __webpack_public_path__ + "img/P1000894.365d27de.jpg";